import { ChartData, ChartOptions } from 'chart.js'

/**
 * Creates donut chart data for dental visualizations
 */
export const createChartData = (
  current: number,
  total: number,
  label: string,
  currentColor: string = '#48BB78'
): ChartData<'doughnut'> => {
  const remaining = Math.max(0, total - current)
  return {
    labels: [`Current ${label}`, `Removed ${label}`],
    datasets: [
      {
        data: [current, remaining],
        backgroundColor: [
          currentColor,
          '#48BB78', // Chakra green.500 (Removed/Remaining) - always green
        ],
        borderWidth: 0,
      },
    ],
  }
}

/**
 * Creates donut chart options for dental visualizations
 */
export const createChartOptions = (title: string): ChartOptions<'doughnut'> => {
  return {
    cutout: '70%',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: title,
        font: {
          size: 14,
          weight: 'bold' as const,
        },
      },
      legend: {
        position: 'bottom' as const,
        labels: {
          boxWidth: 12,
          padding: 5,
        },
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const total = context.dataset.data.reduce(
              (acc: number, val: number) => acc + val,
              0
            )
            const value = context.parsed || 0
            const percentage =
              total > 0 ? ((value / total) * 100).toFixed(0) : '0'
            return `${context.label}: ${percentage}%`
          },
        },
      },
    },
  }
}
